import { render, staticRenderFns } from "./yek-valmistumispyynnot-card.vue?vue&type=template&id=6ff57f4e&scoped=true&"
import script from "./yek-valmistumispyynnot-card.vue?vue&type=script&lang=ts&"
export * from "./yek-valmistumispyynnot-card.vue?vue&type=script&lang=ts&"
import style0 from "./yek-valmistumispyynnot-card.vue?vue&type=style&index=0&id=6ff57f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff57f4e",
  null
  
)

export default component.exports